/**
 * Module:	Sign In Dialog for Periscope
 * Title:	Text
 */

import {tr} from '@alias_root/src/framework/ods/ods';

//
//	Constants
//

export const TC = {
	pageTitle: 'Main - Login',
	// static text
	errormsg: tr('This field is required!', 'Dieses Feld ist ein Pflichtfeld'),
	eyeIconTitle: tr('Show password in clear text', 'Passwort im Klartext darstellen'),
} as const;

// export const TITLE = TC.pageTitle;
